export const pagesPlacesLaborCoreEn = {
  common: {
    edit: 'Edit'
  },
  employmentInsurance: {
    fields: {
      officeNumber: 'Office Number',
      publicEmploymentSecurityOffice: 'Public Employment Security Office (Hello Work)',
      searchPlaceholder: 'Search for Public Employment Security Office...'
    },
    title: 'Employment Insurance'
  },
  healthInsurance: {
    fields: {
      addHealthInsuranceAssociationLink: 'Edit society type and name in People > Settings',
      healthInsuranceAssociation: 'Health Insurance Association',
      healthInsuranceOffice: 'Association Submission Destination',
      healthInsuranceReportingDestination: 'Health Insurance Reporting Destination',
      name: 'Name',
      officeReferenceNumber: 'Office Reference Number',
      selectHealthInsuranceAssociation: 'Select Health Insurance Association...',
      type: 'Type'
    },
    title: 'Health Insurance'
  },
  incomeTax: {
    fields: {
      taxOfficeCode: 'Tax Office Code',
      taxOfficeName: 'Tax Office Name'
    },
    title: 'Income Tax'
  },
  localTax: {
    fields: {
      representativeDepartment: 'Representative - Department',
      representativeName: 'Representative - Name',
      representativeNameKana: 'Representative - Name (Kana)',
      representativePhoneNumber: 'Representative - Phone Number',
      specialCollectionNumber: 'Special Collection Number'
    },
    title: 'Local Tax'
  },
  navigation: {
    employmentInsurance: 'Employment Insurance',
    healthInsurance: 'Health Insurance',
    incomeTax: 'Income Tax',
    localTax: 'Local Tax',
    pensionInsurance: 'Pension Insurance',
    socialInsuranceBasic: 'Social Insurance Basic',
    workersCompensation: "Workers' Compensation"
  },
  pensionInsurance: {
    fields: {
      officeNumber: 'Office Number',
      officeReferenceNumber: 'Office Reference Number'
    },
    title: 'Pension Insurance'
  },
  socialInsuranceBasic: {
    fields: {
      address: 'Address',
      addressKana: 'Address (Kana)',
      identificationName: 'Identification Name (Name not displayed in documents for identification purposes)',
      pensionOffice: 'Pension Office',
      pensionOfficeCenter: 'Pension Office Center',
      pensionOfficeCenterSearchPlaceholder: 'Search for Pension Office Center...',
      pensionOfficeSearchPlaceholder: 'Search for Pension Office...',
      phoneNumber: 'Phone Number',
      representative: 'Representative',
      representativeTitle: 'Representative Title',
      socialInsuranceName: 'Social Insurance Name',
      socialInsuranceNameKana: 'Social Insurance Name (Kana)'
    },
    title: 'Social Insurance Basic'
  },
  workersCompensation: {
    fields: {
      laborBureau: 'Labor Bureau',
      laborBureauSearchPlaceholder: 'Search for Labor Bureau...',
      laborStandardsOffice: 'Labor Standards Inspection Office',
      laborStandardsOfficeSearchPlaceholder: 'Search for Labor Standards Office...',
      officeNumber: 'Office Number'
    },
    title: "Workers' Compensation"
  }
};